import { RightBanner } from "../../../components/SeniorMindsetBanner"

export default RightBanner
